import { render, staticRenderFns } from "./ClientFiltersTable.vue?vue&type=template&id=da294588&"
import script from "./ClientFiltersTable.vue?vue&type=script&lang=js&"
export * from "./ClientFiltersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports